import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DemoValidUntil({ validUntil }: { validUntil: string }) {
  const { t } = useTranslation();
  return (
    <Typography
      variant="h5"
      sx={{
        border: '1px solid #e0e0e0',
        padding: '5px',
        borderRadius: '5px',
      }}
    >
      {t('header.validUntil', {
        val: new Date(validUntil),
        formatParams: {
          val: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          },
        },
      })}
    </Typography>
  );
}
